import Vue from "vue";
import Vuex from "vuex";

import lessons from "./modules/lessons";
import schools from "./modules/schools";
import classes from "./modules/classes";
import session from "./modules/session";
import students from "./modules/students";
import reports from "./modules/reports";
import teachers from "./modules/teachers";
import grammarToGo from "./modules/grammar-to-go";
import knowledgeBase from "./modules/knowledge-base";
import users from "./modules/users";

import { State as ILessonsModuleState } from "./modules/lessons";
import { State as IClassesModuleState } from "./modules/classes";
import { State as ISchoolsModuleState } from "./modules/schools";
import { State as ISessionModuleState } from "./modules/session";
import { State as IStudentsModuleState } from "./modules/students";
import { State as IReportsModuleState } from "./modules/reports";
import { State as ITeachersModuleState } from "./modules/teachers";
import { State as IGrammarToGoState } from "./modules/grammar-to-go";
import { State as IKnowledgeBaseState } from "./modules/knowledge-base";

// root state without modules
// to be filled as soon as needed
export interface State {}

export interface IRealRootState extends State {
  lessons: ILessonsModuleState;
  classes: IClassesModuleState;
  schools: ISchoolsModuleState;
  session: ISessionModuleState;
  students: IStudentsModuleState;
  reports: IReportsModuleState;
  teachers: ITeachersModuleState;
  grammarToGo: IGrammarToGoState;
  knowledgeBase: IKnowledgeBaseState;
}

Vue.use(Vuex);

export default new Vuex.Store<State>({
  modules: {
    lessons,
    schools,
    session,
    classes,
    students,
    reports,
    teachers,
    grammarToGo,
    knowledgeBase,
    users
  }
});
